import { render, staticRenderFns } from "./VkAccounts.vue?vue&type=template&id=467152f6"
import script from "./VkAccounts.vue?vue&type=script&lang=js"
export * from "./VkAccounts.vue?vue&type=script&lang=js"
import style0 from "./VkAccounts.vue?vue&type=style&index=0&id=467152f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports